import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear);

export const DEFAULT_OVERLAY_COLOR = 'rgba(0,0,0,0.3)';
export const DEFAULT_FONT_OVERLAY_COLOR = '#ffffff';
export const MEDIA_TYPE_VIDEO = 'MEDIA_TYPE_VIDEO';
export const ERRORS = {
  robot_not_valid: 'Robot is invalid',
  invalid_configuration: 'Robot has invalid configuration',
  get_flow_request_error: 'Error occured getting flow',
  no_project_assigned: 'This avatar has no project assigned anymore. Please assign or reach out to the creator for assistants',
  no_published_content: 'This project needs to be published before it is available for this avatar.',
  server_error: 'Something went wrong',
  flow_not_found: 'Flow not found',
  frame_not_found: 'Frame is not assigned to the robot',
  external_robot_command_processing_error: 'Frame has invalid external robot commands data',
  external_robot_chat_processing_error: 'Frame has invalid external robot chats data',
  google_access_token_error: 'We are preparing the preview for you. Please check back in 1min.',
  link_wrong_or_expired: 'Link expired or wrong. Please check url and/or reach out to the creator.',
  no_avatar_found: 'Sorry, no avatar found',
};

export const FLOW_STATE_OPTIONS = {
  SYSTEM_START: 'system_start',
  USER_HOME_BUTTON: 'user_home_button',
  USER_LANGUAGE_SWITCH: 'user_language_switch',
  SYSTEM_LANGUAGE_SWITCH: 'system_language_switch',
  SYSTEM_BACK_TO_START: 'system_back_to_start',
};

export const INTERACTION_DELAY = 500; // synced with native team
export const API_CALL_TIMEOUT = 5000; // synced with native team
export const API_CALL_BODY_TYPES = {
  FORM_DATA: 'multipart/form-data',
  URL_ENCODED: 'application/x-www-form-urlencoded',
  JSON: 'application/json',
  TEXT: 'text/plain',
  HTML: 'text/html',
};
export const CUSTOM_SCRIPT_TIMEOUT = 30000;
export const QR_READER_TIMEOUT = 20000;
export const START_FLOW_ID = 'start';
export const RETURN_FLOW_ID = 'return';
export const SOLITARY_FLOW_ID = 'solitary';
export const SYSTEM_VARIABLES_MAP = {
  FLOW_STATE: { id: '7d9e3f8c-b2a4-4e91-8f6d-c5a9d1b3e0f2', name: 'FlowState' },
  AGE: { id: '79efb18a-42e3-11ec-81d3-0242ac130003', name: 'Age' },
  MASK: { id: '637846bf-26aa-4eaa-aa8e-48f63d144f2b', name: 'Mask' },
  GENDER: { id: '80aea6b6-42e3-11ec-81d3-0242ac130003', name: 'Gender' },
  USER_ID: { id: '861f5b9a-42e3-11ec-81d3-0242ac130003', name: 'User ID' },
  KNOWN_HUMAN: { id: '624a044c-9a90-4f08-a2de-f1a2b8519779', name: 'Known Human' },
  SESSION_ID: { id: '776c630f-3062-4672-bbe0-df0315367609', name: 'SessionID' },
  SESSION_START_TIME: { id: 'e81862c9-6a7c-40b4-a464-57218cb74714', name: 'Session Start Time' },
  ROBOT_ID: { id: 'bbed53af-2939-4e20-92fc-bb846005ff99', name: 'RobotID' },
  ROBOT_NAME: { id: 'eefbfdb0-9dd2-4666-bfdc-6766f65c2cbe', name: 'RobotName' },
  TIME: {
    id: '18f8c107-233f-471d-be48-a5bcae8dbc7c',
    name: 'Time',
    value() {
      return dayjs().format('HH:mm');
    },
  },
  TIME_MORNING: {
    id: '0b00f604-ae32-432b-b629-c66f846b7880',
    name: 'TimeMorning',
    value: ['00:00', '08:59'],
  },
  TIME_DAY: {
    id: '10a9c3d5-1f27-4940-b5d6-0a9a9678eb9d',
    name: 'TimeDay',
    value: ['09:00', '12:59'],
  },
  TIME_AFTERNOON: {
    id: 'd7ea3708-50a8-4f76-b33e-3cfa09424a7a',
    name: 'TimeAfternoon',
    value: ['13:00', '15:59'],
  },
  TIME_EVENING: {
    id: '07b8e4e0-4429-4e85-bfe7-43413f3d4475',
    name: 'TimeEvening',
    value: ['16:00', '23:59'],
  },
  DATE: {
    id: '1588b2f0-7c56-4019-9254-f614aa2a41db',
    name: 'Date',
    value() {
      return dayjs().format('DD.MM.YYYY');
    },
    compareValue() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      return date.getTime();
    },
  },
  DAY_NUMBER: {
    id: '344794b8-2408-442e-b71f-a01045be1a2b',
    name: 'DayNumber',
    value() {
      return dayjs().format('DD:MM');
    },
  },
  WEEK_DAY_NUMBER: {
    id: '2b2d440b-1c51-4147-a66b-3662200756c5',
    name: 'WeekdayNumber',
    value() {
      return dayjs().day();
    },
  },
  WEEK_NUMBER: {
    id: '6d5555af-7b99-4571-9e12-d1f61011c5ec',
    name: 'WeekNumber',
    value() {
      return dayjs().week();
    },
  },
  YEAR: {
    id: 'a918bb78-7eef-4dc1-9fdb-90b30e42ac93',
    name: 'Year',
    value() {
      return dayjs().year();
    },
  },
  MONTH: {
    id: 'c0cd83bf-df5c-49d7-a1c3-68337d266ed6',
    name: 'Month',
    value() {
      return dayjs().month() + 1; // month counts from "0" O_o
    },
  },
  VOICE_INPUT: { id: '582777a8-a1b9-46ec-8901-0c7d9b733cbf', name: 'UserVoiceInput' },
  LANGUAGE_NAME: { id: 'be3bdd4e-d8d1-46c8-9275-3aed988387ca', name: 'LanguageName' },
  LANGUAGE_ISO1: { id: '38461b04-1c79-4b68-a591-1752607abdab', name: 'LanguageISO1' },
  LANGUAGE_ISO2: { id: '9a1ef52b-5346-44d2-969e-50300467c716', name: 'LanguageISO2' },
  AVAILABLE_LANGUAGES: { id: '7f8e9a1b-3c2d-4e6f-9a5b-8d7c6f5e4d3a', name: 'AvailableLanguages' },
  ENABLED_LANGUAGES: { id: '2f9e8d1c-4b3a-4f5e-9d7c-1e6b5a3c8f2d', name: 'EnabledLanguages' },
  PLURAL_AVATAR_ID: { id: 'de00f79f-2109-45ae-9f0c-8a6d6bb51316', name: 'PluralAvatarID' },
  KB_RESPONSE: { id: 'bf7e24e9-743f-48f6-a14b-93cf5d13120e', name: 'KBResponse' },
  KB_THREAD_ID: { id: 'b0e9c755-3e9b-4e50-b649-4ffac7447373', name: 'KBThreadId' },
  KB_CONVERSATION_HISTORY: { id: 'e0d52ee5-57e1-42c4-b40b-3b9ea26f2b32', name: 'KBConversationHistory' },
  KB_POST_ANSWER_MESSAGE_VARIABLE_ID: { id: '6049297c-8896-4c71-8eb9-ab05cd93c7e5', name: 'KBPostAnswerMessage' },
  DATE_ISO: {
    id: '32f7843c-20f7-4e6b-a1b0-a208fb64e4d9',
    name: 'DateIso',
    value() {
      return dayjs().format('YYYY-MM-DD');
    },
    compareValue() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      return date.getTime();
    },
  },
  DATE_TIME_ISO: {
    id: '99dcd2bb-8d93-40a8-86ed-fa16c92b7700',
    name: 'DateTimeIso',
    value() {
      return dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS');
    },
    compareValue() {
      const date = new Date();
      return date.getTime();
    },
  },
  TIME_ISO: {
    id: '26e78a3c-b65f-4b7a-aa8a-65a02df5469a',
    name: 'TimeIso',
    value() {
      return dayjs().format('HH:mm:ss.SSS');
    },
  },
  DB_TOKEN: {
    id: '92ba723d-abc4-445a-8547-27c28d11d396',
    name: 'DatabaseToken',
  },
  CURRENT_DESIGN_ELEMENT: {
    id: '4d7e9f2c-6b3a-4e8d-9c5f-2a8b1d3e0f4a',
    name: 'CurrentDesignElementId',
  },
};

export const TIME_OF_DAY_VARIABLES = [
  SYSTEM_VARIABLES_MAP.TIME_MORNING.id,
  SYSTEM_VARIABLES_MAP.TIME_DAY.id,
  SYSTEM_VARIABLES_MAP.TIME_AFTERNOON.id,
  SYSTEM_VARIABLES_MAP.TIME_EVENING.id,
];

export const SYSTEM_VARIABLES = [
  SYSTEM_VARIABLES_MAP.AGE,
  SYSTEM_VARIABLES_MAP.MASK,
  SYSTEM_VARIABLES_MAP.GENDER,
  SYSTEM_VARIABLES_MAP.USER_ID,
  SYSTEM_VARIABLES_MAP.KNOWN_HUMAN,
  SYSTEM_VARIABLES_MAP.TIME,
  SYSTEM_VARIABLES_MAP.TIME_MORNING,
  SYSTEM_VARIABLES_MAP.TIME_DAY,
  SYSTEM_VARIABLES_MAP.TIME_AFTERNOON,
  SYSTEM_VARIABLES_MAP.TIME_EVENING,
  SYSTEM_VARIABLES_MAP.DATE,
  SYSTEM_VARIABLES_MAP.SESSION_ID,
  SYSTEM_VARIABLES_MAP.SESSION_START_TIME,
  SYSTEM_VARIABLES_MAP.ROBOT_ID,
  SYSTEM_VARIABLES_MAP.ROBOT_NAME,
  SYSTEM_VARIABLES_MAP.DAY_NUMBER,
  SYSTEM_VARIABLES_MAP.WEEK_DAY_NUMBER,
  SYSTEM_VARIABLES_MAP.WEEK_NUMBER,
  SYSTEM_VARIABLES_MAP.YEAR,
  SYSTEM_VARIABLES_MAP.MONTH,
  SYSTEM_VARIABLES_MAP.VOICE_INPUT,
  SYSTEM_VARIABLES_MAP.LANGUAGE_NAME,
  SYSTEM_VARIABLES_MAP.LANGUAGE_ISO1,
  SYSTEM_VARIABLES_MAP.LANGUAGE_ISO2,
  SYSTEM_VARIABLES_MAP.AVAILABLE_LANGUAGES,
  SYSTEM_VARIABLES_MAP.ENABLED_LANGUAGES,
  SYSTEM_VARIABLES_MAP.PLURAL_AVATAR_ID,
  SYSTEM_VARIABLES_MAP.KB_RESPONSE,
  SYSTEM_VARIABLES_MAP.KB_THREAD_ID,
  SYSTEM_VARIABLES_MAP.KB_CONVERSATION_HISTORY,
  SYSTEM_VARIABLES_MAP.KB_POST_ANSWER_MESSAGE_VARIABLE_ID,
  SYSTEM_VARIABLES_MAP.DATE_ISO,
  SYSTEM_VARIABLES_MAP.DATE_TIME_ISO,
  SYSTEM_VARIABLES_MAP.TIME_ISO,
  SYSTEM_VARIABLES_MAP.DB_TOKEN,
  SYSTEM_VARIABLES_MAP.FLOW_STATE,
  SYSTEM_VARIABLES_MAP.CURRENT_DESIGN_ELEMENT,
];
export const VARIABLE_VALUE_TYPES = {
  PRIMITIVE: 'primitive',
  VARIABLE: 'variable',
};

export const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const CHATBOT_TYPES = {
  CUSTOM: 'CUSTOM',
  ROBOT: 'ROBOT',
  GLOBAL: 'GLOBAL',
};

export const FRAME_PROTOCOL = {
  SPEECH: 'say',
  SET_VARIABLES: 'set_variable',
  CLOSE: 'close',
};

export const WEBSITE_CONTAINER_SIZES = {
  FULLSCREEN: 'fullscreen',
  FULLSCREEN_IN_FRONT: 'fullscreen-in-front',
  HALF_SIZE: 'halfsize',
  QUARTER_SIZE: 'quarter-size',
  SQUARE_SIZE: 'square-size',
};

export const USER_INPUT_DEFAULT_PLACEHOLDERS = {
  text: 'Enter text…',
  phone: '+49 555 555 55',
  email: 'email@example.com',
  number: '1234...',
  time: '08:00',
  date: '04.11.2016',
  timeDate: '08:00 | 04.11.2016',
  dropdown: 'Select…',
  canvas: '',
};

export const MEDIA_BREAKPOINTS = {
  WIDTH: {
    MOBILE: 360,
    TABLET: 680,
    DESKTOP_S: 1081,
    DESKTOP_M: 1440,
    DESKTOP_L: 1921,
    DESKTOP_XL: 2561,
    TV_SCREEN: 3840,
  },
  HEIGHT: {
    MOBILE: 480,
    BIG_VERTICAL_SCREEN: 3840,
  },
};
